<div class="modal-content p-4">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'modal.invite_monitored_user.title' | translate }}
    </h5>
    <button type="button" class="btn-secondary btn close" (click)="close()">
      <span>&times;</span>
    </button>
  </div>

  <div class="modal-body pt-0">
    <ng-container [ngSwitch]="step">
      <div *ngSwitchCase="'enterEmail'">
        <div class="mb-2">
          {{ 'modal.invite_monitored_user.message_question' | translate }}
        </div>

        <label for="emailAddress" class="form-label">
          {{ 'auth.forms.email_address' | translate }}
        </label>

        <input
          id="emailAddress"
          name="emailAddress"
          type="email"
          class="form-control form-control-lg"
          [formControl]="emailAddress"
          [class.is-invalid]="emailAddress.touched && emailAddress.invalid"
        />

        <div class="invalid-feedback" *ngIf="emailAddress.hasError('required')">
          {{ 'auth.forms.email_required_error' | translate }}
        </div>
        <div class="invalid-feedback" *ngIf="emailAddress.hasError('pattern')">
          {{ 'auth.forms.email_invalid_error' | translate }}
        </div>
      </div>

      <div *ngSwitchCase="'confirmInvite'">
        <p class="mb-0">
          {{ 'modal.invite_monitored_user.not_found_question' | translate }}
        </p>
        <p class="text-muted small">
          {{ 'modal.invite_monitored_user.actions_hint' | translate }}
        </p>
      </div>

      <div *ngSwitchCase="'composeEmail'">
        <div [formGroup]="composeForm" class="row g-2">
          <div class="col-12">
            <label class="form-label">{{ 'modal.email.to' | translate }}</label>
            <input class="form-control" formControlName="to" />
          </div>
          <div class="col-12">
            <label class="form-label">{{ 'modal.email.subject' | translate }}</label>
            <input class="form-control" formControlName="subject" />
          </div>
          <div class="col-12">
            <label class="form-label">{{ 'modal.email.body' | translate }}</label>
            <textarea rows="8" class="form-control" formControlName="body"></textarea>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer pt-2 px-2">
    <ng-container [ngSwitch]="step">
      <div *ngSwitchCase="'enterEmail'" class="d-flex gap-2">
        <button class="btn btn-secondary" (click)="close()">
          {{ 'modal.default_cancel_button' | translate }}
        </button>

        <button class="btn btn-primary" (click)="handleCheckEmail()">
          {{ 'modal.invite_monitored_user.submit' | translate }}
        </button>
      </div>

      <div *ngSwitchCase="'confirmInvite'" class="d-flex gap-2">
        <button class="btn btn-secondary" (click)="handleDeclineInvite()">
          {{ 'modal.default_no_button' | translate }}
        </button>
        <button class="btn btn-primary" (click)="handleProceedToCompose()">
          {{ 'modal.invite_monitored_user.invite_yes' | translate }}
        </button>
      </div>

      <div *ngSwitchCase="'composeEmail'" class="d-flex gap-2">
        <button class="btn btn-secondary" (click)="close()">
          {{ 'modal.default_cancel_button' | translate }}
        </button>
        <button class="btn btn-success" (click)="handleSendInvitation()">
          {{ 'modal.invite_monitored_user.send_invitation' | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</div>

<app-async-state-overlay [processKeys]="asyncProcessKeys"></app-async-state-overlay>
